// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2cUaf","selected":"Chip_selected__vGQ2B"};